import styled from '@emotion/styled';
import sizes from 'modules/application-link/domain/constants/sizes';
import UDButton from 'ud-ui/components/button';
import { theme } from 'styles/theme/theme';

const styles = {
  Button: styled(UDButton)`
    transition:
      background-color 0.2s ease-in-out,
      color 0.2s ease-in-out;

    &:disabled {
      background-color: ${theme.colors.DisabledInputColor} !important;
      outline: ${theme.colors.DisabledInputColor} !important;
      border: 1px solid ${theme.colors.DisabledInputColor} !important;
      color: ${({ theme }) => theme.colors.DarkBlue} !important;

      cursor: not-allowed;
    }
  `,
  CheckboxContainer: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    @media (max-width: ${sizes.mobile.WIDTH}px) {
      justify-content: start;
    }
  `,
};

export default styles;
